var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
var SvgResultChart = function SvgResultChart(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#7791B4"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M5.833 10.833H4.167a.833.833 0 0 0-.834.834v4.166c0 .46.373.834.834.834h1.666c.46 0 .834-.373.834-.834v-4.166a.833.833 0 0 0-.834-.834M10.833 7.5H9.167a.833.833 0 0 0-.834.833v7.5c0 .46.373.834.834.834h1.666c.46 0 .834-.373.834-.834v-7.5a.833.833 0 0 0-.834-.833M15.833 3.75h-1.666a.833.833 0 0 0-.834.833v11.25c0 .46.373.834.834.834h1.666c.46 0 .834-.373.834-.834V4.583a.833.833 0 0 0-.834-.833"
  }))));
};
export default SvgResultChart;